import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

type AdicionarTipoEmbalagem = {
  onSave: (tipos: { tipoEmbalagem: string }) => Promise<boolean>;
  onCancel: () => void;
};

const AdicionarTipoEmbalagem = ({ onSave, onCancel }: AdicionarTipoEmbalagem) => {
  const [tipoEmbalagem, setTipoEmbalagem] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (tipoEmbalagem.trim().length === 0) {
      toast.error("Preencha o campo antes de enviar");
      return;
    }

    setLoading(true);
    try {
      const success = await onSave({ tipoEmbalagem: tipoEmbalagem.trim() });

      if (success) {
        toast.success("Embalagem criado com sucesso!");
        setTipoEmbalagem("");
        window.location.reload();
      } else {
        toast.error("Erro ao criar Embalagem.");
      }
    } catch (error) {
      toast.error("Erro inesperado ao criar Embalagem.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Overlay>
      <ModalContainer>
        <Title>Adicionar tipo de embalagem</Title>
        <InputGroup>
          <Input
            type="text"
            value={tipoEmbalagem}
            onChange={(e) => setTipoEmbalagem(e.target.value)}
            placeholder="Tipo de embalagem"
            disabled={loading}
          />
          <Label>Tipo de embalagem</Label>
        </InputGroup>

        <ButtonGroup>
          <ButtonCancelar onClick={onCancel} disabled={loading}>
            Voltar
          </ButtonCancelar>
          <ButtonEnviar onClick={handleSubmit} disabled={loading}>
            {loading ? "Enviando..." : "Enviar"}
          </ButtonEnviar>
        </ButtonGroup>
      </ModalContainer>
    </Overlay>
  );
};

export default AdicionarTipoEmbalagem;

// === styled-components ===

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(20, 25, 41, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContainer = styled.div`
  background: white;
  width: 380px;
  padding: 30px 28px;
  border-radius: 8px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.14);
`;

const Title = styled.h2`
  font-size: 22px;
  color: #2c3e50;
  margin-bottom: 44px;
  text-align: center;
`;

const InputGroup = styled.div`
  position: relative;
  margin-bottom: 30px;
  `;

const Input = styled.input`
display: flex;
justify-content: space-between;
  width: 100%;
  padding: 12px 12px 12px 12px;
  font-size: 16px;
  border: 1.8px solid #cfd8dc;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #007bff;
  }
`;

const Label = styled.label`
  position: absolute;
  left: 14px;
  top: -10px;
  background: white;
  padding: 0 6px;
  font-size: 13px;
  color: #607d8b;
  pointer-events: none;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ButtonBase = styled.button`
  flex: 1;
  padding: 12px 0;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s;
  border: none;
  margin: 0 8px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const ButtonEnviar = styled(ButtonBase)`
  background-color: rgb(183, 152, 97);
  color: white;

  &:hover:not(:disabled) {
    background-color: rgba(99, 68, 15, 0.747);
  }
`;

const ButtonCancelar = styled(ButtonBase)`
  background-color: #e0e0e0;
  color: #444;

  &:hover:not(:disabled) {
    background-color: #bdbdbd;
  }
`;
